import api from './api';

const getFormData = (file, { projectId, fieldName }) => {
  const formData = new FormData();
  const metadata = JSON.stringify({ projectId, fieldName });

  formData.append('file', file);
  formData.append('metadata', metadata);

  return formData;
};

export const uploadService = (file, metadata) => {
  const formData = getFormData(file, metadata);

  return api.post('projects/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const deliverFile = (data, name) => {
  const resUrl = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = resUrl;
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
};

export const downloadService = async (id, name) => {
  const response = await api.get(`projects/files/${id}`, {
    responseType: 'blob',
  });

  deliverFile(response.data, name);
};

export const getFiles = id => {
  return api.get(`projects/${id}/files`);
};

export const deleteService = async id => {
  await api.delete(`projects/files/${id}`);
};
